import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import RateTableFooter from 'components/footer'
import WidgetPage from 'components/hocs/widget-page'
import withExperimentProvider from 'components/hocs/withExperimentProvider'
import { useViewport } from 'components/hooks'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import get from 'lodash.get'
import { getFooterDisclosure } from './utils.js'
import VerticalTabsSection from './components/tabs-section'
import styles from './styles.scss'

const variations = ['full', 'resizable', 'fixed-height']

const getAdvertiserDisclosure = (theme, widgetContext) => {
  // Defaults to true if error occurs finding showDisclosure property
  const showDisclosure = get(widgetContext, ['options', 'multiVertical', 'showDisclosure'], true)

  if (!showDisclosure) return null

  switch (theme) {
    case 'fox':
    case 'fox1':
      return (
        <AdvertiserDisclosure
          theme={theme}
          tooltipId="multi-vertical-advertiser-disclosure"
        />
      )
    default:
      return null
  }
}

const convertVerticals = (verticals) => {
    if (typeof verticals === 'string') {
      return verticals.split(',')
    }
    return verticals
  },

  getTooltipOffSet = () => {
    const width = useViewport()

    return width < 400 ? '{"bottom": -30}' : ''
  },

  RateTableApp = ({ verticals, variation, theme, widgetContext, ...props }) => {
    // lodash.get keys into 1st arg using 2nd arg's keys and defaults to 3rd arg on error
    const titleText = get(widgetContext, ['options', 'multiVertical', 'titleText'], 'Shop around. One marketplace.'),
      subTitleText = get(widgetContext, ['options', 'multiVertical', 'subTitleText'], 'Select a product to compare rates'),

      cssCls = variations.includes(variation) ? variation : 'fixed-height',
      [vertical, setVertical] = useState(''),
      verticalsOption = convertVerticals(verticals),
      partner = ['credible', 'yahoo1'],
      title = partner.includes(theme) ? theme : 'title',
      background = (theme === 'yahoo1' && variation !== 'full') ? 'yahoo-background' : ''

    return (
      <div className={[styles.outerContainer, styles[cssCls]].join(' ')}>
        {getAdvertiserDisclosure(theme, widgetContext)}
        <div className={[styles.contentContainer, styles[background], styles[theme]].join(' ')}>
          <Font type="heading" weight="bold" className={`${styles[title]} mb-16 mb-sm-0`}>
            {titleText}
          </Font>
          <Font type="bodySmall" className={`${styles[title]} mb-16 hidden-xs`}>
            {subTitleText}
          </Font>
          <VerticalTabsSection
            verticals={verticalsOption}
            variation={variation}
            setVertical={setVertical}
            theme={theme}
            widgetContext={widgetContext}
            {...props}
          />
          <RateTableFooter
            theme={theme}
            footerDisclosure={getFooterDisclosure(vertical)}
            noMargin
            multiVertical
            offSet={getTooltipOffSet()}
          />
        </div>
      </div>
    )
  }

RateTableApp.propTypes = {
  verticals: PropTypes.array,
  variation: PropTypes.string,
  theme: PropTypes.string,
  widgetContext: PropTypes.shape({
    options: PropTypes.shape({
      multiVertical: PropTypes.shape({
        showDisclosure: PropTypes.bool,
        titleText: PropTypes.string,
        subTitleText: PropTypes.string,
        defaultFilters: PropTypes.object,
      }),
    }),
  }),
}

export { RateTableApp, getAdvertiserDisclosure }

export default WidgetPage(withExperimentProvider(RateTableApp))
